class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.isLoading = false;
    this.isLoaded = false;
    this.onCartDrawerOpened = this.onCartDrawerOpened.bind(this);
  }

  connectedCallback() {
    document.addEventListener('cartdrawer:opened', this.onCartDrawerOpened);
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
    this.observer.observe(this);
  }

  disconnectedCallback() {
    document.removeEventListener('cartdrawer:opened', this.onCartDrawerOpened);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  onCartDrawerOpened() {
    this.loadRecommendations();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.loadRecommendations();
  }

  loadRecommendations() {
    if (this.isLoaded || this.isLoading) return;
    if (!this.dataset || !this.dataset.url) {
      console.warn('cart-recommendations: missing data-url');
      return;
    }

    this.isLoading = true;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.isLoaded = true;
        }
        // Scroll the mini-cart drawer to the top after recommendations load
        const miniCartMain = document.querySelector('#main-cart-items');
        if (miniCartMain) {
          miniCartMain.scrollTop = 0;
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
